import React from 'react'
import { FaFacebookF, FaInstagram, FaLinkedin, FaWhatsapp, FaGithub } from "react-icons/fa"
import { Link, HStack, } from '@chakra-ui/react';
const Contacts = (props) => {

    const colors = props.colors;

    const WhatsappButtonClicked = (event) => {
        const whatsappMessage = `Hey, My name is ________.
    I saw your portfolio and wanted to get in touch with you about _______________.`;
        const whatsappUrl = `https://wa.me/+601135702780/?text=${encodeURIComponent(whatsappMessage)}`;
        window.open(whatsappUrl, "_blank");
        }
  return (
    <HStack justifyContent={'center'} 
                  alignItems={'flex-start'}
                  w={{base: '100%',md: '100%',lg: '100%'}}
                  gap="1em" py="0.2em" px={'0.5em'}>
                    
              <Link 
              href="https://github.com/ayaan278">
                  <span size='md' >
                  <FaGithub color={colors} style={{fontSize: '40px' }}/>
                  </span>
              </Link>
              <Link 
              href="https://www.facebook.com/ayaan.ahmad.14/">
                <span size='md' >
                  <FaFacebookF  color={colors} style={{fontSize: '40px'}}/>
                </span>
              </Link>
              <Link 
              href="https://www.instagram.com/_.ayaanii._/">
                <span size='md' >
                  <FaInstagram  color={colors} style={{fontSize: '40px'}}/>
                </span>
              </Link>
              <Link 
              onClick={WhatsappButtonClicked}>
                <span size='md' >
                  <FaWhatsapp color={colors} style={{fontSize: '40px'}}/>
                </span>
              </Link>
              <Link 
              href="https://www.linkedin.com/in/ayaan-ahmad-06545614a/">
                <span size='md' >
                  <FaLinkedin color={colors}  style={{fontSize: '40px'}}/>
                </span>
              </Link>

            </HStack>
  )
}

export default Contacts